import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.includes.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/images/icons/icon_check.svg';
import _imports_1 from '@/assets/images/icons/icon_checked.svg';
import _imports_2 from '@/assets/images/coupon_split_line.svg';
var _hoisted_1 = {
  class: "main-info-content"
};
var _hoisted_2 = {
  class: "coupon-name"
};
var _hoisted_3 = {
  class: "discount"
};
var _hoisted_4 = {
  class: "icon-checkbox-wrap"
};
var _hoisted_5 = {
  class: "icon-checkbox",
  src: _imports_0,
  alt: ""
};
var _hoisted_6 = {
  class: "icon-checkbox",
  src: _imports_1,
  alt: ""
};
var _hoisted_7 = {
  class: "extend-info"
};
var _hoisted_8 = {
  class: "extend-info-main"
};
var _hoisted_9 = {
  class: "icon-drop-wrap"
};
var _hoisted_10 = {
  class: "extend-info-extend"
};
var _hoisted_11 = {
  key: 0,
  class: "extend-item"
};
var _hoisted_12 = {
  key: 1,
  class: "extend-item extend-item--error"
};
var _hoisted_13 = {
  key: 2,
  class: "extend-item extend-item--error"
};
var _hoisted_14 = {
  key: 3,
  class: "extend-item extend-item--error"
};
var _hoisted_15 = {
  key: 4,
  class: "extend-item extend-item--error"
};
var _hoisted_16 = {
  key: 5,
  class: "extend-item extend-item--error"
};
var _hoisted_17 = {
  key: 6,
  class: "extend-item extend-item--error"
};
import { computed, ref } from "vue";
// import Coupon from "@/views/rewards/Coupon.vue";
import { formatCouponReward, formatDateWithTZ } from "@/utils/format";
import { getOrderTypeLabelMap } from "@/constant/order";
import { DiscountTypeEnum } from "@/constant/coupon";
import { priceUtil } from "@op/shared";
import { useI18n } from "vue-i18n";
export default {
  __name: 'SelectCouponItem',
  props: {
    couponItem: {
      type: Object,
      default: function _default() {}
    },
    selectedId: {
      type: String,
      default: ""
    }
  },
  emits: ["select"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var props = __props;
    var emits = __emit;
    var isWithinThreeDays = computed(function () {
      return props.couponItem.end_time > Date.now() && props.couponItem.end_time - Date.now() < 3 * 24 * 60 * 60 * 1000;
    });
    var validUntilDate = computed(function () {
      return isWithinThreeDays.value ? t("expiresInNDays", [Math.ceil((props.couponItem.end_time - Date.now()) / (24 * 60 * 60 * 1000))]) : t("validUntilN", [formatDateWithTZ(props.couponItem.end_time, "YYYY-MM-DD")]);
    });
    var applicableOrderTypeScopeStr = computed(function () {
      var OrderTypeLabelMap = getOrderTypeLabelMap();
      return props.couponItem.coupon.order_types.map(function (item) {
        return OrderTypeLabelMap[item];
      }).join(", ") || "";
    });
    var applicableDishesScopeStr = computed(function () {
      var _props$couponItem$cou;
      return ((_props$couponItem$cou = props.couponItem.coupon.dishes_scope) === null || _props$couponItem$cou === void 0 ? void 0 : _props$couponItem$cou.scope_names.join(", ")) || "";
    });
    var applicableShopScopeStr = computed(function () {
      var _props$couponItem$cou2;
      return ((_props$couponItem$cou2 = props.couponItem.coupon.shop_scope) === null || _props$couponItem$cou2 === void 0 ? void 0 : _props$couponItem$cou2.scope_names.join(", ")) || "";
    });
    var useDayStr = computed(function () {
      var _props$couponItem$cou3;
      return ((_props$couponItem$cou3 = props.couponItem.coupon.using_restriction) === null || _props$couponItem$cou3 === void 0 || (_props$couponItem$cou3 = _props$couponItem$cou3.week_days) === null || _props$couponItem$cou3 === void 0 ? void 0 : _props$couponItem$cou3.join(", ")) || "";
    });
    function handleSelect() {
      emits("select");
    }
    var showExtend = ref(false);
    function handleShowExtend() {
      showExtend.value = !showExtend.value;
    }
    return function (_ctx, _cache) {
      var _props$couponItem$ca, _props$couponItem$ca2, _props$couponItem$ca3, _props$couponItem$ca4, _props$couponItem$ca5, _props$couponItem$ca6, _props$couponItem$ca7, _props$couponItem$ca8;
      var _component_SvgIcon = _resolveComponent("SvgIcon");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["select-coupon", {
          'select-coupon--disabled': __props.couponItem.cannot_use
        }])
      }, [_createElementVNode("div", {
        class: "main-info",
        onClick: handleSelect
      }, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "coupon-img-wrap"
      }, [_createElementVNode("img", {
        class: "coupon-img",
        src: "/img/coupon_bg.3c397b44.png",
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.couponItem.coupon.title), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("enjoyNOffYourOrder", [_unref(formatCouponReward)(__props.couponItem.coupon.discount_type, __props.couponItem.coupon.discount_rule)])), 1)]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_vShow, __props.selectedId !== __props.couponItem.id]]), _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_vShow, __props.selectedId === __props.couponItem.id]])]), _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_2,
        class: "coupon-split-line"
      }, null, -1))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        class: _normalizeClass(["min-spend", {
          'min-spend--error': (_props$couponItem$ca = __props.couponItem.cannot_use_reason_list) === null || _props$couponItem$ca === void 0 ? void 0 : _props$couponItem$ca.includes('min_consumption')
        }])
      }, _toDisplayString(_ctx.$t("minimumSpendN", [_unref(priceUtil).formatBaseUnitToShowPrice(__props.couponItem.coupon.discount_rule.min_consumption, __props.couponItem.coupon.discount_rule.currency)])), 3), _createElementVNode("div", {
        class: "expire",
        onClick: _withModifiers(handleShowExtend, ["stop"])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["expire-info", {
          'expire-info--error': isWithinThreeDays.value
        }])
      }, _toDisplayString(validUntilDate.value), 3), _createElementVNode("div", _hoisted_9, [_createVNode(_component_SvgIcon, {
        name: "drop_down",
        class: _normalizeClass(["icon-drop", {
          'icon-drop--rotate': showExtend.value
        }])
      }, null, 8, ["class"])])])]), _withDirectives(_createElementVNode("div", _hoisted_10, [__props.couponItem.coupon.discount_type === _unref(DiscountTypeEnum).PERCENT && __props.couponItem.coupon.discount_rule.max_discount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("maximumDiscount", [_unref(priceUtil).formatBaseUnitToShowPrice(__props.couponItem.coupon.discount_rule.max_discount, __props.couponItem.coupon.discount_rule.currency)])), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["extend-item", {
          'extend-item--error': (_props$couponItem$ca2 = __props.couponItem.cannot_use_reason_list) === null || _props$couponItem$ca2 === void 0 ? void 0 : _props$couponItem$ca2.includes('order_types')
        }])
      }, _toDisplayString(_ctx.$t("applicableFor")) + " " + _toDisplayString(applicableOrderTypeScopeStr.value), 3), (_props$couponItem$ca3 = __props.couponItem.cannot_use_reason_list) !== null && _props$couponItem$ca3 !== void 0 && _props$couponItem$ca3.includes('shops') ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t("applyToSomeStores", [applicableShopScopeStr.value])), 1)) : _createCommentVNode("", true), (_props$couponItem$ca4 = __props.couponItem.cannot_use_reason_list) !== null && _props$couponItem$ca4 !== void 0 && _props$couponItem$ca4.includes('exclude_shops') ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t("noApplyToSomeStores", [applicableShopScopeStr.value])), 1)) : _createCommentVNode("", true), (_props$couponItem$ca5 = __props.couponItem.cannot_use_reason_list) !== null && _props$couponItem$ca5 !== void 0 && _props$couponItem$ca5.includes('dishes_category_scope') ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t("applyToSomeCategory", [applicableDishesScopeStr.value])), 1)) : _createCommentVNode("", true), (_props$couponItem$ca6 = __props.couponItem.cannot_use_reason_list) !== null && _props$couponItem$ca6 !== void 0 && _props$couponItem$ca6.includes('dishes_scope') ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t("applyToSomeProduct", [applicableDishesScopeStr.value])), 1)) : _createCommentVNode("", true), (_props$couponItem$ca7 = __props.couponItem.cannot_use_reason_list) !== null && _props$couponItem$ca7 !== void 0 && _props$couponItem$ca7.includes('reached_daily_limit') ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t("usageRestrictionOnlyOneCanBeUsedPerDay")), 1)) : _createCommentVNode("", true), (_props$couponItem$ca8 = __props.couponItem.cannot_use_reason_list) !== null && _props$couponItem$ca8 !== void 0 && _props$couponItem$ca8.includes('not_available_today') ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t("dateRestrictionOnlyAvailable", [useDayStr.value])), 1)) : _createCommentVNode("", true)], 512), [[_vShow, showExtend.value]])])], 2);
    };
  }
};